if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('.product-single__media-model-button');
      const remove = this.parentNode.querySelector('.product-single__media-xr-close');

      this.slider = document.querySelector('#Product-Slider');
      button.addEventListener('click', this.loadContent.bind(this));
      this.closeButton = remove;
      remove.addEventListener('click', this.unloadContent.bind(this));
    }

    loadContent() {
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));

        deferredElement.focus();
      }
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },]);
      this.closeButton.hidden = false; this.closeButton.style.display = '';
      this.slider?.classList.add('dots--disabled');
      this.slider?.setDraggable?.(false);
    }
    unloadContent() {
      this.querySelector('video, model-viewer, iframe').remove();
      this.removeAttribute('loaded');
      this.closeButton.hidden = true; this.closeButton.style.display = 'none';
      this.slider?.setDraggable?.(true);
      this.slider?.classList.remove('dots--disabled');
    }
    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },]);
  },
  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) {
    window.ProductModel.loadShopifyXR();
  }
});
// Android opens Scene Viewer in AR first. Other platforms retain Shopify XR.
(() => {
  if (!/android/i.test(navigator.userAgent) || window.dcAndroidARBound) return;
  window.dcAndroidARBound = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-dc-android-ar-src]');
    if (!button || button.disabled || button.hasAttribute('data-shopify-xr-hidden')) return;
    let source;
    try { source = new URL(button.dataset.dcAndroidArSrc, location.href); } catch { return; }
    if (source.protocol !== 'https:') return;
    const params = new URLSearchParams({
      file: source.href,
      mode: 'ar_preferred',
      title: button.getAttribute('data-shopify-title') || document.title
    });
    const intent = 'intent://arvr.google.com/scene-viewer/1.0?' + params.toString()
      + '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url='
      + encodeURIComponent(location.href) + ';end;';
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(intent);
  }, true);
})();
